module.exports = __webpack_public_path__ + "61b67216dd71d28f6f93ca6dbbbbbf35.jpg";